import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  Col,
  Container,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useNavigate, useParams } from "react-router-dom"
import {
  fetchRevisions,
  updateRevisionStatus,
} from "../../../services/estimation/estimation"
import { toastSuccess } from "../../../helpers/msg_helper"
import downloadicon from "../../../assets/icons/download.svg"
import { samplePdfFileDownload } from "../../../services/Inventory/inventory"
import moment from "moment"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import LoadingButton from "../../../components/Common/LoadingButton"
// import RenderAccordion from "./renderAccord"
import EstimateRenderTable from "./renderTable"
import NumberFormat from "../../../utils/numberFormat"
import MobileNumberFormat from "../../../utils/mobilenumberformat"
import { capitalize } from "lodash"
import PaymentTermsTempList from "../../../components/Common/chooseFields/paymentTermTempLi"
import DownloadIcon from "../../../assets/icons/iconComponents/downloadIcon"
const ViewRoughEstimations = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Estimation${companyname ? ` | ${companyname}` : "MEP -Hub"}`
  const [revision, setRevisions] = useState()
  const [refresh, setRefresh] = useState(0)
  const [revisionType, setRevisionType] = useState({ index: "", status: false })
  const { id } = useParams()
  const [activeTab, setActiveTab] = useState("1")
  const [isfetchatdata, setFeatchedata] = useState()

  const navigate = useNavigate()

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")
  // useEffect(() => {
  //   const fetchData = async id => {
  //     const response = await fetchRevisions(id)
  //     setRevisions(
  //       loggedUser?.permission?.some(
  //         permissionItem => permissionItem?.name === "Convert to Project"
  //       ) &&
  //         loggedUser?.data?.id !== 1 &&
  //         loggedUser?.data?.roles?.some(
  //           designation => designation?.name != "Estimation Manager"
  //         )
  //         ? response?.data?.filter(item => item?.status === "1")
  //         : response?.data
  //     )
  //     setOpen(null);
  //     // setOpen(
  //     //   (loggedUser?.permission?.some(
  //     //     permissionItem => permissionItem?.name === "Convert to Project"
  //     //   ) &&
  //     //     loggedUser?.data?.id !== 1) ||
  //     //     response?.data?.length == 1
  //     //     ? 0
  //     //     : 0
  //     //   // : response?.data?.length - 1
  //     // )
  //   }
  //   if (loggedUser?.data?.id) {
  //     fetchData(id)
  //   }
  // }, [refresh, loggedUser])

  useEffect(() => {
    const fetchData = async id => {
      const response = await fetchRevisions(id)
      setFeatchedata(response?.data?.[0])
      const rawRevisions =
        loggedUser?.permission?.some(
          permissionItem => permissionItem?.name === "Convert to Project"
        ) &&
        loggedUser?.data?.id !== 1 &&
        loggedUser?.data?.roles?.some(
          designation => designation?.name !== "Estimation Manager"
        )
          ? response?.data?.filter(item => item?.status === "1")
          : response?.data

      // Process the revisions with our helper function
      const processedRevisions = getRevisionData(rawRevisions)
      setRevisions(processedRevisions)

      // Automatically open the accordion if there's only one revision
      if (processedRevisions.length === 1) {
        setOpen(0) // Open the first accordion item
      } else {
        setOpen(null) // Close all accordion items
      }
    }

    if (loggedUser?.data?.id) {
      fetchData(id)
    }
  }, [refresh, loggedUser, id])
  const handleRevisionDownload = ({ id, type, fileName }) => {
    const handleCommonExport = async id => {
      const response = await samplePdfFileDownload(
        type == "short"
          ? `estimation/pdf-mini-statement/${id}`
          : `estimation/pdf/${id}`,
        fileName
      )
    }
    handleCommonExport(id)
  }

  const [open, setOpen] = useState(null)
  const toggle = id => {
    if (open === id) {
      setOpen(null)
    } else {
      setOpen(id)
    }
  }
  const getRevisionData = revisions => {
    if (!revisions || revisions.length === 0) return []

    // Sort revisions by created_at date (oldest first)
    const sortedRevisions = [...revisions].sort(
      (a, b) => new Date(a.created_at) - new Date(b.created_at)
    )

    return sortedRevisions.map((rev, index) => ({
      ...rev,
      isCostingSheet: index === 0, // First item is Costing Sheet
      revisionNumber: index === 0 ? null : index, // Others get revision numbers
    }))
  }
  const handleApprove = item => {
    const updateStatus = async item => {
      setIsLoading(true)
      const response = await updateRevisionStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
      navigate(`/project-master/add/${item}`)
      setIsLoading(false)
    }
    updateStatus(item)
  }
  const handleRevisionType = index => {
    if (revisionType?.index === index) {
      setRevisionType({ index: index, status: !revisionType?.status })
    } else {
      setRevisionType({ index: index, status: true })
    }
  }

  const calculateTaskTotal = task => {
    let total = 0
    if (task.estimation_manpower && task.estimation_manpower.length > 0) {
      total += task.estimation_manpower.reduce(
        (sum, item) => sum + parseFloat(item.price || 0),
        0
      )
    }
    if (task.estimation_material && task.estimation_material.length > 0) {
      total += task.estimation_material.reduce(
        (sum, item) =>
          sum + parseFloat(item.price || 0) * parseFloat(item?.quantity),
        0
      )
    }
    if (task.estimation_subcontract && task.estimation_subcontract.length > 0) {
      total += task.estimation_subcontract.reduce(
        (sum, item) => sum + parseFloat(item.price || 0),
        0
      )
    }
    // console.log(`profitPercentage total`, total)

    return total
  }

  const calculateTaskAndSubtasksTotal = (task, profitPercentage) => {
    let total = calculateTaskTotal(task)
    if (task.tasks && task.tasks.length > 0) {
      total += task.tasks.reduce(
        (sum, subtask) =>
          sum + calculateTaskAndSubtasksTotal(subtask, profitPercentage),
        0
      )
    }

    const sumTotal =
      Number(total) + Number(total) * (Number(profitPercentage) / 100)
    console.log(
      `profitPercentage profitPercentage :`,
      profitPercentage,
      total,
      sumTotal
    )

    return sumTotal
  }

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const [isLoading, setIsLoading] = useState(false)
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between me-2">
            <Breadcrumbs
              title="Estimation"
              breadcrumbObject={[
                { title: "Estimation", link: "/estimation" },
                { title: "Estimations List", link: "/estimation/quotation" },
                {
                  title: "Revision List",
                  link: `/estimation/quotation-view/${id}`,
                },
              ]}
            />
          </div>
          <Container fluid className="ps-lg-0">
            <Card className="supplier-card">
              <div>
                <Accordion open={open} toggle={toggle}>
                  {revision &&
                    revision?.map((dt, index) => {
                      const totalMaterialPrice =
                        dt?.estimation_material?.reduce(
                          (total, item) => total + Number(item?.price),
                          0
                        ) || 0

                      const totalSubcontractsPrice =
                        dt?.estimation_subcontract?.reduce(
                          (total, item) => total + Number(item?.price),
                          0
                        ) || 0
                      const totalManpowersPrice =
                        dt?.estimation_manpower?.reduce(
                          (total, item) => total + Number(item?.price),
                          0
                        ) || 0
                      const totalOverheadsPrice =
                        (((dt?.estimation_material?.reduce(
                          (total, item) => total + Number(item?.price),
                          0
                        ) || 0) +
                          (dt?.estimation_subcontract?.reduce(
                            (total, item) => total + Number(item?.price),
                            0
                          ) || 0) +
                          (dt?.estimation_manpower?.reduce(
                            (total, item) => total + Number(item?.price),
                            0
                          ) || 0)) *
                          Number(dt?.client_code?.overheads_per)) /
                        100

                      const totalPrelimsPrice =
                        (((dt?.estimation_material?.reduce(
                          (total, item) => total + Number(item?.price),
                          0
                        ) || 0) +
                          (dt?.estimation_subcontract?.reduce(
                            (total, item) => total + Number(item?.price),
                            0
                          ) || 0) +
                          (dt?.estimation_manpower?.reduce(
                            (total, item) => total + Number(item?.price),
                            0
                          ) || 0)) *
                          Number(dt?.client_code?.preliminary_per)) /
                        100
                      const subTotal =
                        totalMaterialPrice +
                        totalOverheadsPrice +
                        totalSubcontractsPrice +
                        totalManpowersPrice +
                        totalPrelimsPrice
                      const taxAmount = (subTotal * Number(dt?.tax)) / 100
                      const discountAmount =
                        (subTotal * Number(dt?.discount)) / 100
                      const TotalAmount = subTotal + taxAmount - discountAmount

                      const calculateTotal = item => {
                        const sumArray = (arr, multiplierKey) =>
                          Array.isArray(arr)
                            ? arr.reduce(
                                (total, current) =>
                                  total +
                                  Number(current?.price || 0) *
                                    Number(current?.[multiplierKey] || 1),
                                0
                              )
                            : 0

                        const totalMaterial = sumArray(
                          item?.estimation_material,
                          "quantity"
                        )
                        const totalManpower = sumArray(
                          item?.estimation_manpower,
                          "no_of_labours"
                        )
                        const totalSubcontract = sumArray(
                          item?.estimation_subcontract,
                          "duration"
                        )

                        // Recursively calculate total for nested tasks
                        // const totalSubTasks = Array.isArray(item?.tasks)
                        //   ? item.tasks.reduce((sum, subTask) => sum + calculateTotal(subTask), 0)
                        //   : 0

                        // Return the final numeric total
                        return totalMaterial + totalManpower + totalSubcontract
                        // + totalSubTasks
                      }

                      const sumTotal = calculateTotal(dt)
                      // +
                      // calculateTotal(projectTasks) * (projectProfit / 100)
                      // console.log(`sumTotal`, sumTotal)

                      // setTasks(response?.data?.tasks)

                      let marginValuePercent = 0
                      if (dt?.estimation?.margin_value != 0) {
                        marginValuePercent =
                          (Number(dt?.estimation?.margin_value) /
                            Number(sumTotal)) *
                          100
                      } else {
                        marginValuePercent = 0
                      }

                      const profitPercentage =
                        dt?.estimation?.margin_percentage != 0
                          ? dt?.estimation?.margin_percentage
                          : dt?.estimation?.margin_value != 0
                          ? marginValuePercent
                          : 0

                      console.log(`profitPercentage`, profitPercentage)

                      return (
                        <AccordionItem key={index}>
                          <AccordionHeader
                            targetId={index}
                            className={
                              revision?.length > index + 1 && `account-header`
                            }
                          >
                            <div className="d-flex justify-content-between w-100">
                              <span className="text-bold d-flex align-items-center">
                                {index === 0
                                  ? "Costing Sheet"
                                  : `Revision ${`${index}`.padStart(
                                      2,
                                      "0"
                                    )}`}{" "}
                                {dt?.status == 1 && (
                                  <span className="font-13 status-active ms-2">
                                    Approved
                                  </span>
                                )}
                                {/* <img
                                  src={downloadicon}
                                  alt="Download"
                                  className="trash-img pointer ms-2"
                                  onClick={e => {
                                    e.stopPropagation()
                                    handleRevisionDownload({
                                      id: dt?.id,
                                      type:
                                        revisionType?.index == index &&
                                        revisionType?.status == true
                                          ? "short"
                                          : "long",
                                    })
                                  }}
                                /> */}
                                {console.log(`revisionType`, revisionType)}
                                <span
                                  className="trash-img pointer ms-2"
                                  onClick={e => {
                                    e.stopPropagation()
                                    handleRevisionDownload({
                                      id: dt?.id,
                                      type:
                                        revisionType?.index == index &&
                                        revisionType?.status == true
                                          ? "short"
                                          : "long",
                                      fileName: `Quotation-${
                                        dt?.client_code?.project_name
                                          ? dt?.client_code?.project_name
                                          : "New"
                                      }`,
                                    })
                                  }}
                                  title={"Download"}
                                >
                                  <DownloadIcon />
                                </span>
                              </span>
                            </div>
                          </AccordionHeader>
                          <AccordionBody accordionId={index}>
                            <Row className="">
                              <Col sm={12}>
                                <Row>
                                  <Col lg={4} md={4} sm={4}>
                                    <Row className="py-3">
                                      <Col className="text-bold">Info</Col>
                                    </Row>
                                    <Row>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Estimation ID
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {dt?.client_code?.estimation_code}
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Estimation Date
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {moment(
                                          dt?.client_code?.created_at
                                        ).format("DD-MM-YYYY")}
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Estimation Created By
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {capitalize(
                                          dt?.client_code?.estimate_created_by
                                        )}
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Project Bid Date
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {moment(
                                          dt?.estimation?.bid_date
                                        ).format("DD-MM-YYYY")}
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Project Progress Date
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {dt?.estimation?.from_date &&
                                        dt?.estimation?.to_date
                                          ? `${moment(
                                              dt?.estimation?.from_date
                                            ).format("DD-MM-YYYY")} - ${moment(
                                              dt?.estimation?.to_date
                                            ).format("DD-MM-YYYY")}`
                                          : dt?.estimation?.from_date
                                          ? moment(
                                              dt?.estimation?.from_date
                                            ).format("DD-MM-YYYY")
                                          : dt?.estimation?.to_date
                                          ? moment(
                                              dt?.estimation?.to_date
                                            ).format("DD-MM-YYYY")
                                          : "-"}
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col lg={6} md={4} sm={4}>
                                    <Row className="py-3">
                                      <Col className="text-bold">To</Col>
                                    </Row>
                                    <Row>
                                      <Col
                                        lg={3}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Client Code
                                      </Col>
                                      <Col
                                        lg={9}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {
                                          dt?.client_code?.customers
                                            ?.customer_code
                                        }
                                      </Col>
                                      <Col
                                        lg={3}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Client Name
                                      </Col>
                                      <Col
                                        lg={9}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3 lh-sm"
                                      >
                                        {dt?.client_code?.customers
                                          ?.customer_name
                                          ? capitalize(
                                              dt?.client_code?.customers
                                                ?.customer_name
                                            )
                                          : ""}
                                      </Col>
                                      <Col
                                        lg={3}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Project Name
                                      </Col>
                                      <Col
                                        lg={9}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {capitalize(
                                          dt?.client_code?.project_name
                                        )}
                                      </Col>
                                      <Col
                                        lg={3}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Project Location
                                      </Col>
                                      <Col
                                        lg={9}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {dt?.client_code?.location?.name}
                                      </Col>
                                      <Col
                                        lg={3}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Client Contact Person
                                      </Col>
                                      <Col
                                        lg={9}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {dt?.client_code?.client_contact_person
                                          ? dt?.client_code
                                              ?.client_contact_person
                                          : "-"}
                                      </Col>
                                      <Col
                                        lg={3}
                                        md={6}
                                        sm={6}
                                        className="text-mute pb-3"
                                      >
                                        Contact Number
                                      </Col>
                                      <Col
                                        lg={9}
                                        md={6}
                                        sm={6}
                                        className="text-medium pb-3"
                                      >
                                        {MobileNumberFormat(
                                          "+" + dt?.client_code?.contact_number
                                        )}
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col
                                    lg={2}
                                    md={4}
                                    sm={4}
                                    className="d-flex justify-content-end"
                                  >
                                    <span>
                                      <Button
                                        form={`supplier-form`}
                                        color={"primary"}
                                        className={"px-2 mb-3 btn btn-primary"}
                                        onClick={() =>
                                          handleRevisionType(index)
                                        }
                                      >
                                        {revisionType?.index == index &&
                                        revisionType?.status == true
                                          ? "Short Revision"
                                          : "Long Revision"}
                                      </Button>
                                    </span>
                                  </Col>
                                </Row>
                                {revisionType?.index == index &&
                                revisionType?.status == true ? (
                                  <Row className="mb-4">
                                    <Col lg={12}>
                                      <table className="estimation-table mt-5 ev-work-progress-tbl">
                                        <thead>
                                          <tr>
                                            {/* <th>SL No</th> */}
                                            <th>Items</th>
                                            {/* <th className="aline-rig">
                                              Price (AED)
                                            </th> */}
                                            <th className="text-end">Qty</th>
                                            <th>Unit</th>
                                            <th className="text-end">Rate</th>

                                            <th className="text-end">
                                              Materials
                                            </th>
                                            <th className="text-end">
                                              Fittings
                                            </th>
                                            <th className="text-end">
                                              Consumables
                                            </th>
                                            <th className="text-end">Labor</th>
                                            <th className="text-end">
                                              Sub Cont
                                            </th>
                                            <th className="text-end pe-1">
                                              OHP
                                            </th>
                                            <th className="pe-4 text-end">
                                              Amount
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {/* {dt?.estimation_material?.length ? (
                                            dt?.tasks?.map((item, index) => (
                                              <tr key={index}>
                                                <td className="ps-2">
                                                  {item?.name}
                                                </td>
                                                <td className="aline-rig">
                                                  {NumberFormat(
                                                    Number(
                                                      calculateTaskAndSubtasksTotal(
                                                        item,
                                                        profitPercentage
                                                      )
                                                    ),
                                                    desimalrange,
                                                    desimalrange
                                                  )}
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <></>
                                          )} */}
                                          {/* {dt?.estimation_material?.length && */}
                                          {dt?.tasks?.length ? (
                                            <EstimateRenderTable
                                              tasks={dt?.tasks}
                                              projectProfit={profitPercentage}
                                              longrevision={true}
                                            />
                                          ) : (
                                            <></>
                                          )}
                                        </tbody>
                                      </table>
                                      <Row
                                        className={`d-flex align-items-center py-2 ${
                                          revisionType?.index == index &&
                                          revisionType?.status == true
                                            ? "pe-2"
                                            : ""
                                        } `}
                                      >
                                        <Col
                                          lg={
                                            revisionType?.index == index &&
                                            revisionType?.status == true
                                              ? 10
                                              : 9
                                          }
                                          className="text-end dark-text"
                                        >
                                          Net Total (AED)
                                        </Col>
                                        <Col
                                          lg={
                                            revisionType?.index == index &&
                                            revisionType?.status == true
                                              ? 2
                                              : 3
                                          }
                                          className={
                                            revisionType?.index == index &&
                                            revisionType?.status == true
                                              ? "pe-4 text-end dark-text"
                                              : "ps-5 dark-text"
                                          }
                                        >
                                          {NumberFormat(
                                            Number(dt?.amount),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </Col>
                                      </Row>
                                      {discountAmount ? (
                                        <Row className="d-flex align-items-center py-2">
                                          <Col
                                            lg={9}
                                            className="text-end dark-text"
                                          >
                                            Discount(
                                            {NumberFormat(
                                              Number(dt?.discount)
                                            )}{" "}
                                            %)
                                          </Col>
                                          <Col
                                            lg={3}
                                            className="ps-5 dark-text"
                                          >
                                            {NumberFormat(
                                              Number(discountAmount),
                                              desimalrange,
                                              desimalrange
                                            )}
                                          </Col>
                                        </Row>
                                      ) : (
                                        <></>
                                      )}

                                      <Row className="d-flex align-items-center py-2">
                                        {/* <Col
                                          lg={9}
                                          className="text-end dark-text"
                                        >
                                          Total Amount(AED)
                                        </Col>
                                        <Col lg={3} className="ps-5 dark-text">
                                          {Number(
                                            Number(TotalAmount).toFixed(desimalrange)
                                          ).toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                          })}
                                        </Col> */}
                                      </Row>
                                      {revision.every(
                                        item => item?.status == 0
                                      ) &&
                                        (loggedUser?.permission?.some(
                                          permissionItem =>
                                            permissionItem?.name ===
                                            "Estimation Approve"
                                        ) ||
                                          loggedUser?.data?.id === 1) && (
                                          <Row className={`d-flex justify-content-end pt-4 ${
                                          revisionType?.index == index &&
                                          revisionType?.status == true
                                            ? "pe-2"
                                            : ""}
                                        `}>
                                            <Col
                                              lg={3}
                                              className={
                                                revisionType?.index == index &&
                                                revisionType?.status == true
                                                  ? "text-end pe-1"
                                                  : "ps-5"
                                              }
                                            >
                                              <LoadingButton
                                                form={`supplier-form`}
                                                color={"primary"}
                                                className={
                                                  "px-2 mb-3 btn btn-primary"
                                                }
                                                onClick={() =>
                                                  handleApprove(dt?.id)
                                                }
                                                loading={isLoading}
                                                disabled={isLoading}
                                              >
                                                Approve
                                              </LoadingButton>
                                            </Col>
                                          </Row>
                                        )}
                                    </Col>
                                  </Row>
                                ) : (
                                  <>
                                    {dt?.tasks?.length ? (
                                      <>
                                        <Nav tabs>
                                          <NavItem>
                                            <NavLink
                                              className={
                                                activeTab === "1"
                                                  ? "active pointer py-2"
                                                  : "pointer py-2"
                                              }
                                              onClick={() => toggleTab("1")}
                                            >
                                              Detail
                                            </NavLink>
                                          </NavItem>
                                          {dt?.estimation_payment_terms
                                            ?.length > 0 && (
                                            <NavItem>
                                              <NavLink
                                                className={
                                                  activeTab === "2"
                                                    ? "active pointer py-2"
                                                    : "pointer py-2"
                                                }
                                                onClick={() => toggleTab("2")}
                                              >
                                                Payment Term
                                              </NavLink>
                                            </NavItem>
                                          )}
                                        </Nav>

                                        <TabContent
                                          activeTab={activeTab}
                                          className="pt-3"
                                        >
                                          <TabPane tabId="1">
                                            <Row className="">
                                              <table className="estimation-table mb-2 ev-work-progress-tbl">
                                                <thead>
                                                  <tr>
                                                    <th rowSpan="2">
                                                      Item Description
                                                    </th>
                                                    <th
                                                      rowSpan="2"
                                                      className="text-end"
                                                    >
                                                      Qty
                                                    </th>
                                                    <th rowSpan="2">Unit</th>
                                                    <th
                                                      rowSpan="2"
                                                      className="text-end"
                                                    >
                                                      Rate
                                                    </th>
                                                    <th
                                                      rowSpan="2"
                                                      className="pe text-end"
                                                    >
                                                      Amount
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <EstimateRenderTable
                                                    tasks={dt?.tasks}
                                                    projectProfit={
                                                      profitPercentage
                                                    }
                                                  />
                                                </tbody>
                                              </table>
                                            </Row>
                                          </TabPane>

                                          {dt?.estimation_payment_terms
                                            ?.length > 0 && (
                                            <TabPane tabId="2">
                                              <Row className="mb-4">
                                                <table className="estimation-table mb-2 ev-work-progress-tbl">
                                                  <thead>
                                                    <tr>
                                                      <th>Description</th>
                                                      <th className="text-end pe-2">
                                                        Invoice Portion %
                                                      </th>
                                                      <th className="text-end pe-2">
                                                        Invoice Amount
                                                      </th>
                                                      <th className="text-end pe-3">
                                                        Due Date
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {dt?.estimation_payment_terms?.map(
                                                      (data, index) => (
                                                        <tr key={index}>
                                                          <td className="text-capitalize ps-2">
                                                            {data?.description ||
                                                              "-"}
                                                          </td>
                                                          <td className="text-end pe-2">
                                                            {data?.invoice_portion ||
                                                              "-"}
                                                          </td>
                                                          <td className="text-end pe-2">
                                                            {NumberFormat(
                                                              Number(
                                                                data?.invoice_amount ||
                                                                  0
                                                              ),
                                                              desimalrange,
                                                              desimalrange
                                                            )}
                                                          </td>
                                                          <td className="text-end pe-3">
                                                            {moment(
                                                              data?.due_date
                                                            ).format(
                                                              "DD-MM-YYYY"
                                                            )}
                                                          </td>
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </table>
                                              </Row>
                                            </TabPane>
                                          )}
                                        </TabContent>
                                      </>
                                    ) : null}

                                    {activeTab === "1" && (
                                      <Row className="d-flex align-items-center py-2 pt-0 ">
                                        <Col
                                          lg={10}
                                          className="text-end dark-text"
                                        >
                                          Net Total (AED)
                                        </Col>
                                        <Col
                                          lg={2}
                                          className="dark-text"
                                          style={{ paddingLeft: "3.5rem" }}
                                        >
                                          {NumberFormat(
                                            Number(dt?.amount),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </Col>
                                      </Row>
                                    )}
                                    {discountAmount ? (
                                      <Row className="d-flex align-items-center py-2">
                                        <Col
                                          lg={10}
                                          className="text-end dark-text"
                                        >
                                          Discount(
                                          {NumberFormat(
                                            Number(dt?.discount)
                                          )}{" "}
                                          %)
                                        </Col>
                                        <Col lg={2} className="ps-5 dark-text">
                                          {NumberFormat(
                                            Number(discountAmount),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </Col>
                                      </Row>
                                    ) : (
                                      <></>
                                    )}

                                    <Row className="d-flex align-items-center py-2"></Row>

                                    {revision.every(
                                      item => item?.status == 0
                                    ) &&
                                      (loggedUser?.permission?.some(
                                        permissionItem =>
                                          permissionItem?.name ===
                                          "Estimation Approve"
                                      ) ||
                                        loggedUser?.data?.id === 1) && (
                                        <Row className="d-flex justify-content-end pt-4">
                                          <Col lg={2} className="ml-to-move-right-approve">
                                            <LoadingButton
                                              form={`supplier-form`}
                                              color={"primary"}
                                              className={
                                                "px-2 mb-3 btn btn-primary"
                                              }
                                              onClick={() =>
                                                handleApprove(dt?.id)
                                              }
                                              loading={isLoading}
                                              disabled={isLoading}
                                            >
                                              Approve
                                            </LoadingButton>
                                          </Col>
                                        </Row>
                                      )}
                                  </>
                                )}
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                      )
                    })}
                </Accordion>
              </div>
            </Card>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewRoughEstimations
